import PlusIcon from 'assets/icons/plus.svg';
import MinusIcon from 'assets/icons/minus.svg';
import { MenuItem } from '@templates/FooterMenu/FooterMenu.types';
import Link from '@components/atoms/Link';
import Typography from '@components/atoms/Typography';
import Collapsible from '@components/Collapsible';

import classes from './CollapsibleMenuList.module.scss';

type Props = Omit<MenuItem, 'id'> & { isPhone?: boolean };

const CollapsibleMenuList = ({ items = [], name, isPhone = false }: Props): JSX.Element => (
  <section className={classes.wrapper}>
    <Collapsible
      trigger={(isOpen, handleClick) => (
        <Typography
          renderAs="div"
          variant="h4"
          weight={isOpen ? '700' : '400'}
          className={classes.trigger}
          onClick={handleClick}
        >
          <div>{name}</div>
          {isOpen ? <MinusIcon width={11} /> : <PlusIcon width={11} />}
        </Typography>
      )}
    >
      <div className={classes.list}>
        {items.map(({ id, url, name: itemName }) => {
          const content = (
            <Typography key={id} variant="body2" renderAs="span" className={classes.link}>
              {itemName}
            </Typography>
          );
          return isPhone ? (
            content
          ) : (
            <Link key={id} component="span" href={url}>
              {content}
            </Link>
          );
        })}
      </div>
    </Collapsible>
  </section>
);

export default CollapsibleMenuList;
